import { forwardRef, useCallback, useMemo } from 'react'
import styles from './autoComplete.module.scss'
import { useGetTranslation } from 'components/Translations/translationUtils'

type Props = {
	item: any
	getItemText(item: any): string | undefined
	onClick(item: any): void
	isSelected?: boolean
	getItemStyle?: (item: any) => React.CSSProperties
}

export const Option = forwardRef((
	{ item, getItemText, onClick, isSelected, getItemStyle, }: Props,
	ref: React.ForwardedRef<HTMLDivElement> | undefined
) => {
	const getTranslation = useGetTranslation();

	const onClickCallback = useCallback(
		() => {
			onClick(item);
		},
		[item, onClick]
	)

	const itemStyleMemo = useMemo(
		() => getItemStyle && getItemStyle(item),
		[item, getItemStyle]
	)

	const className = `${styles.option} ${isSelected ? styles.selected : ''}`

	return (
		<div
			ref={ref}
			className={className}
			style={itemStyleMemo}
			onMouseDown={onClickCallback}
		>
			{getTranslation(getItemText(item))}
		</div>
	)
})
